export class StateDidNotRespondToAction extends Error {
    constructor(state, action) {
        super();
        this.state = state;
        this.action = action;
    }
    toString() {
        return `State "${this.state.name}" could not respond to action: ${this.action.type}`;
    }
}
export class NoStatesRespondToAction extends Error {
    constructor(states, action) {
        super();
        this.states = states;
        this.action = action;
    }
    toString() {
        return `No states "${this.states
            .map(s => s.name)
            .join(", ")}" could not respond to action: ${this.action.type}`;
    }
}
export class NoMatchingActionTargets extends Error {
}
export class MissingCurrentState extends Error {
}
export class EnterExitMustBeSynchronous extends Error {
}
export class UnknownStateReturnType extends Error {
}
//# sourceMappingURL=errors.js.map